import { render, staticRenderFns } from "./BorcluVekiliForm.vue?vue&type=template&id=568226bc"
import script from "./BorcluVekiliForm.vue?vue&type=script&lang=ts"
export * from "./BorcluVekiliForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports